'use client';

import SectionCard from '@/app/(website)/components/SectionCard';
import SectionHeader from '@/app/(website)/components/SectionHeader';
import CheckCircle from '@/assets/icons/CheckCircle.svg';
import Clock from '@/assets/icons/Clock.svg';
import Flash from '@/assets/icons/Flash.svg';
import Rocket from '@/assets/icons/Rocket.svg';
import { useEffect, useRef, useState } from 'react';

export default function HighlightsArchEng() {
  const [isVisible, setIsVisible] = useState(false);
  const gridRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {threshold: 0.2},
    );

    if (gridRef.current) {
      observer.observe(gridRef.current);
    }

    return () => {
      if (gridRef.current) {
        observer.unobserve(gridRef.current);
      }
    };
  }, []);

  const baseClass = 'transition-all duration-1000 ease-in-out transform';

  return (
    <div
      id="highlights"
      className="flex flex-col items-center gap-10 py-16 px-8"
    >
      <SectionHeader
        badgeText="Funzionalità"
        title={
          <>Riduci il tempo operativo,{' '}
            <span className="rounded-[2rem] rounded-br-[8px] py-0 px-2 md:px-4 bg-secondary text-primary">
              aumenta
            </span>{' '}
            qualità ed efficienza
          </>
        }
        subtitle="Con Normo.ai, il professionista dell’edilizia ha un supporto concreto nella ricerca normativa, nell’analisi documentale e nella costruzione di una prima base di lavoro per pratiche, relazioni, verifiche e modulistica."
      />
      <div
        className="grid grid-cols-1 md:grid-cols-2 max-w-[56.625rem] gap-8"
        ref={gridRef}
      >
        <SectionCard
          text="Ottieni risposte articolate con richiami a norme, regolamenti, prassi, linee guida e fonti tecniche, per partire da una base di lavoro più solida."
          title="Risposte con fonti rilevanti"
          icon={<Flash width={64} height={64} />}
          className={`${baseClass} ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-40'
          }`}
        />
        <SectionCard
          text="Resta allineato all’evoluzione normativa nazionale, regionale e locale senza inseguire manualmente aggiornamenti dispersi tra siti, portali e banche dati."
          title="Fonti aggiornate quotidianamente"
          icon={<Clock width={64} height={64} />}
          className={`${baseClass} delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-40'
          }`}
        />
        <SectionCard
          text="Dalla prima bozza di relazione o istanza alla revisione di allegati tecnici e fascicoli complessi: Normo.ai accelera la fase preparatoria del lavoro tecnico-amministrativo."
          title="Analisi, redazione e revisione documentale"
          icon={<CheckCircle width={64} height={64} />}
          className={`${baseClass} delay-500 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-40'
          }`}
        />
        <SectionCard
          text="Non uno strumento chiuso in un solo modulo, ma un supporto utile quando nel caso concreto si intrecciano profili edilizi, urbanistici, energetici, strutturali, paesaggistici, impiantistici e incentivanti."
          title="Lavoro e casi d’uso trasversali"
          icon={<Rocket width={64} height={64} />}
          className={`${baseClass} delay-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-40'
          }`}
        />
      </div>
    </div>
  );
}
